import Vue from "vue"
import Router from "vue-router"
import { Toast } from "vant"
import { wechatLogin } from "@/api/auth"
import { isLoggedIn, saveLoginUserId } from "@/utils/auth"

Vue.use(Router)

const router = new Router({
  routes: [
    { path: "/", redirect: "/customer-track" },
    {
      path: "/customer-track",
      name: "CustomerTrack",
      component: () => import("@/views/CustomerTrack.vue")
    }
  ]
})

let loginPending = false

function extractRedirectUrl(res) {
  if (typeof res === "string") return res
  return (
    res?.url ||
    res?.data?.url ||
    res?.redirectUrl ||
    res?.data?.redirectUrl ||
    res?.loginUrl ||
    res?.data?.loginUrl ||
    ""
  )
}

router.beforeEach(async (to, from, next) => {
  const userId = to.query?.userId

  if (userId) {
    saveLoginUserId(userId)
    const nextQuery = { ...to.query }
    delete nextQuery.userId
    next({
      path: to.path === "/" ? "/customer-track" : to.path,
      query: nextQuery,
      replace: true
    })
    return
  }

  if (isLoggedIn()) {
    next()
    return
  }

  if (loginPending) return
  loginPending = true
  Toast.loading({ message: "跳转企业微信登录...", forbidClick: true, duration: 0 })
  try {
    const res = await wechatLogin()
    const redirectUrl = extractRedirectUrl(res)
    Toast.clear()
    if (!redirectUrl) {
      Toast.fail("未获取到企业微信登录地址")
      next(false)
      return
    }
    window.location.replace(redirectUrl)
  } catch (e) {
    Toast.clear()
    next(false)
  } finally {
    loginPending = false
  }
})

export default router

